import axios from "axios";

const { REACT_APP_API } = process.env;

const getData = (promise) => promise.then((response) => response.data);

export const obterConfiguracaoNivel2 = async () => {
  const data = await getData(axios.get(`${REACT_APP_API}nivel2/configuracao`));

  const tiposVinculoAgregado =
    data?.TiposVinculoAgregado ||
    data?.tiposVinculoAgregado ||
    data?.GrausParentescoAgregado ||
    data?.grausParentescoAgregado ||
    [];

  return {
    MinVidas: data?.MinVidas ?? data?.minVidas,
    MaxVidas: data?.MaxVidas ?? data?.maxVidas,
    PercentualMaxPSPJ: data?.PercentualMaxPSPJ ?? data?.percentualMaxPSPJ,
    PercentualMaxSocios: data?.PercentualMaxSocios ?? data?.percentualMaxSocios,
    IdadeMaximaTitularAgregado:
      data?.IdadeMaximaTitularAgregado ?? data?.idadeMaximaTitularAgregado,
    IdadeMaximaConjuge: data?.IdadeMaximaConjuge ?? data?.idadeMaximaConjuge,
    IdadeMaximaFilho: data?.IdadeMaximaFilho ?? data?.idadeMaximaFilho,
    IdadeMaximaInativo: data?.IdadeMaximaInativo ?? data?.idadeMaximaInativo,
    TempoMaxInatividadeArt30:
      data?.TempoMaxInatividadeArt30 ?? data?.tempoMaxInatividadeArt30,
    TempoMaxInatividadeArt31:
      data?.TempoMaxInatividadeArt31 ?? data?.tempoMaxInatividadeArt31,
    TiposVinculoAgregado: tiposVinculoAgregado,
  };
};

export const listarPatologiasCRM = async () =>
  getData(axios.get(`${REACT_APP_API}nivel2/patologias`));

export const listarPatologiasOportunidade = async (oportunidadeId) =>
  getData(
    axios.get(`${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/patologias`)
  );

export const adicionarPatologia = async (oportunidadeId, body) =>
  getData(
    axios.post(
      `${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/patologias`,
      body
    )
  );

export const removerPatologia = async (oportunidadeId, patologiaRegistroId) =>
  getData(
    axios.delete(
      `${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/patologias/${patologiaRegistroId}`
    )
  );

export const listarInativos = async (oportunidadeId) =>
  getData(axios.get(`${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/inativos`));

export const adicionarInativo = async (body) =>
  getData(axios.post(`${REACT_APP_API}nivel2/inativos`, body));

export const removerInativo = async (oportunidadeId, inativoId) =>
  getData(
    axios.delete(
      `${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/inativos/${inativoId}`
    )
  );

export const listarAgregados = async (oportunidadeId) =>
  getData(axios.get(`${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/agregados`));

export const adicionarAgregado = async (body) =>
  getData(axios.post(`${REACT_APP_API}nivel2/agregados`, body));

export const removerAgregado = async (oportunidadeId, agregadoId) =>
  getData(
    axios.delete(
      `${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/agregados/${agregadoId}`
    )
  );

export const listarReembolsosDisponiveis = async (planoId) =>
  getData(
    axios.get(`${REACT_APP_API}nivel2/reembolsos-disponiveis`, {
      params: { planoId },
    })
  );

export const listarReembolsosOportunidade = async (oportunidadeId) =>
  getData(
    axios.get(`${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/reembolsos`)
  );

export const adicionarReembolso = async (oportunidadeId, body) =>
  getData(
    axios.post(
      `${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/reembolsos`,
      body
    )
  );

export const atualizarReembolso = async (oportunidadeId, reembolsoId, valor) =>
  getData(
    axios.put(
      `${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/reembolsos/${reembolsoId}`,
      { valor }
    )
  );

export const removerReembolso = async (oportunidadeId, reembolsoId) =>
  getData(
    axios.delete(
      `${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/reembolsos/${reembolsoId}`
    )
  );

export const listarArquivos = async (oportunidadeId) =>
  getData(axios.get(`${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/arquivos`));

export const uploadArquivo = async (oportunidadeId, body) =>
  getData(
    axios.post(`${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/arquivos`, body)
  );

export const removerArquivo = async (oportunidadeId, arquivoId) =>
  getData(
    axios.delete(
      `${REACT_APP_API}nivel2/oportunidade/${oportunidadeId}/arquivos/${arquivoId}`
    )
  );

export const atualizarOportunidadeNivel2 = async (
  oportunidadeDTO,
  idAgenteVendas,
  cdAgenteVendas
) =>
  getData(
    axios.put(
      `${REACT_APP_API}oportunidade?IdAgenteVendas=${idAgenteVendas}&CdAgenteVendas=${cdAgenteVendas}`,
      oportunidadeDTO
    )
  );
